export enum SDDTransactionTypeEnum {
  ACTIVE_SDD = 'ACTIVE_SDD',
  ARCHIVE_SDD = 'ARCHIVE_SDD'
}
